import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
} from '@angular/core';
import {
    ReactiveFormsModule,
    Validators,
    AbstractControl,
    ValidationErrors,
    FormGroup,
    FormControl,
    NonNullableFormBuilder,
} from '@angular/forms';
import {TranslatePipe} from '@brunata-angular/util';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {InputTextGroupComponent} from '@brunata-angular/ui';
import {ApiTokenService} from '../api-token.service';
import {ApiToken, CreateApiToken} from '../api-token.model';

type TokenFormGroup = FormGroup<{
    tokenName: FormControl<string>;
    tokenNames: FormControl<string[]>;
}>;

@Component({
    selector: 'app-create-api-token-modal',
    standalone: true,
    imports: [TranslatePipe, ReactiveFormsModule, InputTextGroupComponent],
    templateUrl: './create-api-token-modal.component.html',
    styleUrl: './create-api-token-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateApiTokenModalComponent implements OnInit {
    @Output() readonly apiToken = new EventEmitter<CreateApiToken>();
    @Input() apiTokens: ApiToken[] = [];

    formGroup: TokenFormGroup = this.formBuilder.group({
        tokenName: this.formBuilder.control('', [
            Validators.required,
            CreateApiTokenModalComponent.duplicateNameValidator,
        ]),
        tokenNames: this.formBuilder.control<string[]>([]),
    });

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: NonNullableFormBuilder,
        private apiTokenService: ApiTokenService,
    ) {}

    ngOnInit(): void {
        this.formGroup.controls.tokenNames.setValue(this.apiTokens.map(it => it.tokenName));
    }

    private static duplicateNameValidator(control: AbstractControl): ValidationErrors | null {
        const formGroup = control.parent as TokenFormGroup | null;

        if (formGroup === null) {
            return null;
        }

        const {tokenName, tokenNames} = formGroup.getRawValue();

        if (tokenNames.includes(tokenName)) {
            return {duplicateApiTokenName: true};
        }

        return null;
    }

    submit(): void {
        this.formGroup.markAllAsTouched();

        if (this.formGroup.valid && this.formGroup.value.tokenName != null) {
            this.apiTokenService.createToken(this.formGroup.value.tokenName).subscribe(it => {
                this.apiToken.next(it);
                this.activeModal.close();
            });
        }
    }
}
